import { render, staticRenderFns } from "./BaraChat.vue?vue&type=template&id=bd281e5c&"
import script from "./BaraChat.vue?vue&type=script&lang=js&"
export * from "./BaraChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports